import { Component, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CompaniesService } from 'src/app/core/companies.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';

@Component({
  selector: 'app-companies-sales-reference-email-dialog',
  templateUrl: './companies-sales-reference-email-dialog.component.html',
  styleUrls: ['./companies-sales-reference-email-dialog.component.scss'],
})
export class CompaniesSalesReferenceEmailDialogComponent {
  company_id: string;
  company_sales_reference_email: string;
  set_sales_reference_email_form_group: FormGroup = this.form_service.set_sales_reference_email_form_group;
  error_matcher: FormErrorStateMatcher = this.form_service.matcher;
  is_company_edit_running: boolean = false;

  constructor(
    private dialog_ref: MatDialogRef<CompaniesSalesReferenceEmailDialogComponent>,
    private form_service: FormService,
    private companies_service: CompaniesService,
    private error_service: ErrorService,
    @Inject(MAT_DIALOG_DATA) data: any,
  ) {
    this.company_id = data.company_id;
    this.company_sales_reference_email = data.sales_reference_email;
  }

  ngOnInit(): void {
    this.set_sales_reference_email_form_group
      .get(this.form_service.sales_reference_email_label)
      ?.setValue(this.company_sales_reference_email);
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onConfirmClick(): void {
    if (this.isFormValid()) {
      const sales_reference_email = this.set_sales_reference_email_form_group.get(
        this.form_service.sales_reference_email_label,
      )?.value;
      this.setSalesReferenceEmail(this.company_id, sales_reference_email);
    }
  }

  setSalesReferenceEmail(company_id: string, sales_reference_email: string): void {
    this.is_company_edit_running = true;
    this.companies_service.setSalesReferenceEmail(company_id, sales_reference_email).subscribe({
      next: () => {
        this.dialog_ref.close({ success: true });
        this.is_company_edit_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.dialog_ref.close({ error: processed_error });
        this.is_company_edit_running = false;
      },
    });
  }

  isFormValid(): boolean {
    return this.form_service.validateForm(this.set_sales_reference_email_form_group);
  }
}
